import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { PlanActionStepDTO } from '../../../../types/planActionStepsDTO';
import { PulseCheckCategory } from '../../../../types/goalsDTO';

interface AssignTo {
  value: number;
  label: string;
}

interface UpsertActionStepParams extends Partial<PlanActionStepDTO> {
  AssignTo?: AssignTo;
  clientId: number;
  fpId: string;
  pulseCheckCategory?: PulseCheckCategory;
}

const upsertActionStep = (params: UpsertActionStepParams): Promise<string> => {
  const url = params.Id
    ? '/Consumer/UpdatePlanActionSteps/Update'
    : typeof params.pulseCheckCategory === 'number'
    ? '/Consumer/UpdatePlanActionSteps/CreatePulseCheck'
    : '/Consumer/UpdatePlanActionSteps/Create';

  return authFetch(url, {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useUpsertActionStepMutation = () => {
  return useMutation(upsertActionStep);
};
